import {StripeProductName} from "../../../stripe/models/StripeProductNames";
import {StripeCouponNames} from "../../../stripe/models/StripeCouponNames";
import {StoreProductDefinition, StoreProductMapping} from "../../common/models/StoreProduct";

export enum IvStoreProduct {
    PRO = "PRO",
    BACKTESTING = "BACKTESTING",
    TRADING_SYSTEMS = "TRADING_SYSTEMS",
    BUNDLE = "BUNDLE"
}

const pro: StoreProductDefinition = {
    description: "Pro",
    trial: 7,
    stripeProducts: [StripeProductName.PLATFORM],
    coupon: null
};

const backtesting: StoreProductDefinition = {
    description: "Backtesting",
    trial: 7,
    stripeProducts: [StripeProductName.BACKTESTING],
    coupon: null
};

const tradingSystems: StoreProductDefinition = {
    description: "LITT Trade Alerts",
    trial: 7,
    stripeProducts: [StripeProductName.TRADING_SYSTEMS_ALERTS],
    coupon: null
};

const bundle: StoreProductDefinition = {
    description: "Complete",
    trial: 0,
    stripeProducts: [
        StripeProductName.PLATFORM,
        StripeProductName.BACKTESTING,
        StripeProductName.TRADING_SYSTEMS_ALERTS
    ],
    coupon: StripeCouponNames.BUNDLE_PLATFORM_BACKTESTING_TRADING_ALERTS
};

export const IvProductMappings: StoreProductMapping<IvStoreProduct> = {
    PRO: pro,
    BACKTESTING: backtesting,
    TRADING_SYSTEMS: tradingSystems,
    BUNDLE: bundle
};
